// React
import React, { Component, PropTypes } from 'react';

// CSS
import classNames from 'classnames';
import prefixClassNames from 'SharedComponents/prefixClassNames';
import filterProps from 'SharedComponents/filterProps';
import './OddsBannerCarousel.less';

// Components
import Carousel from 'SharedComponents/Carousel';

@prefixClassNames()
/**
 * ScoresBannerCarousel - Presentation component for OMFEScoresBannerCarousel
 */
export default class OddsBannerCarousel extends Component {

    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node,
    };

    render() {
        const { className, ...restProps } = this.props;
        const newProps = {
            className: classNames(className, { OddsBannerCarousel: true }),
            ...filterProps(restProps, this.constructor.propTypes),
        };

        return (
            <Carousel {...newProps}>
                {this.props.children}
            </Carousel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/OMFEOddsBanner/components/OddsBannerCarousel.js